






import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { RenderPostModel } from "@/services/render/types";
import { GrabPostProperties } from "@/services/posts/postTypes/grab";
import IFrame from "@/components/posts/grab/IFrame.vue";
import { setNextItem } from "../types";
import { logError } from "@/services/logging/loggingService";

@Component({
    components: {
        IFrame: IFrame
    }
})
export default class grabRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private active!: number;
    @Getter("render/getAllowedOrigins") getAllowedOrigins!: string[];

    reload = false;
    reloadComponent = 0;

    // lifecycle hooks
    created() {
        this.setReloadTime();
    }

    mounted() {
        window.addEventListener("message", this.receiveMessage);
    }

    beforeDestroy() {
        window.removeEventListener("message", this.receiveMessage);
    }

    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0 && this.reload) {
            this.reloadIFrame();
        }
        if (value !== 0) {
            this.sendMessage(`showpost:${this.propertiesModel.showTime * 1000}`);
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(
                this.setNextItem,
                this.propertiesModel.showTime * 1000
            );
        }
    }

    get propertiesModel(): GrabPostProperties {
        return this.item.properties
            ? (this.item.properties as GrabPostProperties)
            : ({} as GrabPostProperties);
    }

    setNextItem() {
        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }

    setReloadTime() {
        if (this.propertiesModel.reloadTime <= 0) return;
        setTimeout(this.initReload, this.propertiesModel.reloadTime * 1000);
    }

    initReload() {
        this.reload = true;
        if (this.active) {
            this.reloadIFrame();
        }
    }

    reloadIFrame() {
        this.reload = false;
        this.setReloadTime();
        this.reloadComponent++;
    }

    async receiveMessage(event: any) {
        const lowercaseOriginsList = this.getAllowedOrigins.map(str => str.toLowerCase());
        if (!lowercaseOriginsList.includes(event.origin.toLowerCase())) return;

        if (typeof event.data !== "string") return;

        if (event.data.toLowerCase() === "register") {
            if (this.active !== 0) {
                this.sendMessage(`showpost:${this.propertiesModel.showTime * 1000}`);
            } else {
                this.sendMessage(`duration:${this.propertiesModel.showTime * 1000}`);
            }
        }

        if (event.data.toLowerCase() === "nextpost") {
            clearTimeout(this.setNextItemTimer);
            this.setNextItem();
        }

        if (event.data.toLowerCase().includes("setduration")) {
            const arrOfStr = event.data.split(":");
            const duration = parseInt(arrOfStr[1]) as number;
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(
                this.setNextItem,
                duration * 1000
            );
        }
    }

    isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement => input !== null && input.tagName === "IFRAME";
    sendMessage(message: string) {
        try {
            const url = new URL(this.propertiesModel.url);
            const iframe = document.getElementById(`grab-${this.item.id}`);
            if (iframe && this.isIFrame(iframe) && iframe.contentWindow) {
                iframe.contentWindow.postMessage(message, url.origin);
            } else {
                console.log("Iframe not found or not loaded yet");
            }
        } catch (error) {
            // `postMessage` not supported in older IE versions.
            if (!error.message.toLowerCase().includes("Object doesn't support this action".toLowerCase())) {
                logError(`Website Post with id: ${this.item.id}: Send Message has failed: ${error.toString()}`);
            }
        }
    }

    get size() {
        return {
            width: this.propertiesModel.width + "px",
            height: this.propertiesModel.height + "px"
        };
    }
}
